import React, { useEffect, useRef } from 'react';
import { TreeviewDropdown } from '../../../CommonComponent';
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../../const/resource";
import { IProps } from './shippinginfointerface';
import { Error } from "@progress/kendo-react-labels";
import { MaskedTextBox, TextBox } from '@progress/kendo-react-inputs';

const ShippingInfo = (props: IProps) => {
    const { t } = useTranslation();
    const { shipmentDetails, refs } = props;
    const shippingInfoDiv = useRef<any>(null);

    const phoneInputRef = useRef<any>(null);
    const phoneInputRefText = useRef<any>(null);

    useEffect(() => {
        if (shipmentDetails?.phoneCountryCode && props?.isPhoneUpdated) {
          if(phoneInputRef.current){
            phoneInputRef.current?.focus();
          }
          if (phoneInputRefText?.current) {
            phoneInputRefText.current.element.focus();
          }
          props?.handleIsPhoneUpdated(false);
        }
    }, [shipmentDetails?.phoneCountryCode, props?.isPhoneUpdated]);
    

    return (
        <div>
            <div className="shippinginfo_sub-header" ref={shippingInfoDiv}>
                {t(RESOURCE.MyK_Label_SC_Shipping_Info)}
            </div>
            {shipmentDetails?.weatherWarning && <div className="ErrorMessage_Wrapper">
                {<div className="ErrorMessage_card">
                    <span className="fa fa-exclamation-circle"></span> <span>{t(RESOURCE.MyK_Label_ShoppingCart_Weather_Warning)}</span>
                </div>}
            </div>}
            <div className="shippingcard">

                <div className="row mb-2">
                    <div className="col-6 mb-1">
                        <label>{t(RESOURCE.MyK_Label_ShoppingCart_Saved_Address)}<span className="mandatory">*</span></label>
                    </div>
                    <div className="col-12 col-md-12 col-lg-8 col-xl-12" ref={refs.savedAddress}>
                        <TreeviewDropdown
                            dropdownClassName={'dropdownListContainer noNested'}
                            showSearch={true}
                            treeNodeFilterProp={"title"}
                            treeData={props?.savedAddressOptions ?? []}
                            value={props?.savedAddressList?.loading ? "" : (shipmentDetails?.addressId ?? 0)}
                            onChange={(e: any) => props?.onShippingInfoChange(e, 'savedAddress')}
                        />
                        {(shipmentDetails?.error?.savedAddress) && <Error> {String(t(RESOURCE.MyK_Label_ShoppingCart_Saved_Address_Req))}</Error>}
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-md-6 col-lg-4 col-xl-5 col-6" ref={refs.firstName}>
                        <div className="mb-1">
                            <label>{t(RESOURCE.MyK_Label_ShoppingCart_FirstName)}<span className="mandatory">*</span></label>
                        </div>
                        <div className="col-12 pl-0 pr-0">
                            <input
                                value={shipmentDetails?.firstName ?? ''}
                                onChange={(e: any) => props?.onShippingInfoChange(e?.target?.value ?? '', 'firstName')}
                                type="text" className="textbox"
                            />
                            {(shipmentDetails?.error?.firstName) && <Error> {String(t(RESOURCE.MyK_Label_ShoppingCart_FirstName_Req))}</Error>}
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 col-xl-5 col-6" ref={refs.lastName}>
                        <div className="mb-1">
                            <label >{t(RESOURCE.MyK_Label_ShoppingCart_LastName)}<span className="mandatory">*</span></label>
                        </div>
                        <div className="col-12 pl-0 pr-0">
                            <input
                                value={shipmentDetails?.lastName ?? ''}
                                onChange={(e: any) => props?.onShippingInfoChange(e?.target?.value ?? '', 'lastName')}
                                type="text" className="textbox"
                            />
                            {(shipmentDetails?.error?.lastName) && <Error> {String(t(RESOURCE.MyK_Label_ShoppingCart_LastName_Req))}</Error>}
                        </div>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-12 col-md-12 col-lg-8 col-xl-8" ref={refs.address1}>
                        <div className="mb-1">
                            <label>{t(RESOURCE.MyK_Label_ShoppingCart_StreetAddress)}<span className="mandatory">*</span></label>
                        </div>
                        <div className="col-12 pl-0 pr-0">
                            <input
                                value={shipmentDetails?.address1 ?? ''}
                                onChange={(e: any) => props?.onShippingInfoChange(e?.target?.value ?? '', 'address1')}
                                type="text" className="textbox"
                            />
                            {(shipmentDetails?.error?.address1) && <Error> {String(t(RESOURCE.MyK_Label_ShoppingCart_StreetAddress_Req))}</Error>}
                        </div>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-12 col-md-12 col-lg-8 col-xl-8">
                        <div className="mb-1">
                            <label >{t(RESOURCE.MyK_Label_ShoppingCart_Address2)}</label>
                        </div>
                        <div className="col-12 pl-0 pr-0">
                            <input
                                value={shipmentDetails?.address2 ?? ''}
                                onChange={(e: any) => props?.onShippingInfoChange(e?.target?.value ?? '', 'address2')}
                                type="text" className="textbox"
                            />
                        </div>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-12">
                        <div className="mb-1">
                            <label >{t(RESOURCE.MyK_Label_ShoppingCart_City)}<span className="mandatory">*</span></label>
                        </div>
                    </div>
                    <div className="col-12 col-md-12 col-lg-8 col-xl-8" ref={refs.city}>
                        <input
                            value={shipmentDetails?.city ?? ''}
                            onChange={(e: any) => props?.onShippingInfoChange(e?.target?.value ?? '', 'city')}
                            onBlur={(e: any) => props?.onBlurCity(e?.target?.value ?? '')}
                            type="text" className="textbox" />
                        {(shipmentDetails?.error?.city) && <Error> {String(t(RESOURCE.MyK_Label_ShoppingCart_City_Req))}</Error>}
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-md-6 col-lg-4 col-xl-4 col-6">
                        <div className="mb-1">
                            <label >{t(RESOURCE.MyK_Label_ShoppingCart_Country)}<span className="mandatory">*</span></label>
                        </div>
                        <div className="col-12 pl-0 pr-0" ref={refs.countryName}>
                            <TreeviewDropdown
                                dropdownClassName={'dropdownListContainer noNested'}
                                showSearch={true}
                                treeData={props?.countryList?.data ?? []}
                                value={shipmentDetails?.countryName ?? ''}
                                onChange={(e: any) => props?.onShippingInfoChange(e, 'countryName')}
                            />
                            {(shipmentDetails?.error?.countryName) && <Error> {String(t(RESOURCE.MyK_Label_ShoppingCart_Country_Req))}</Error>}
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 col-xl-4 col-6">
                        <div className="mb-1">
                            <label >{t(RESOURCE.MyK_Label_ShoppingCart_State)}<span className="mandatory">*</span></label>
                        </div>
                        <div className="col-12 pl-0 pr-0" ref={refs.stateName}>
                            <TreeviewDropdown
                                dropdownClassName={'dropdownListContainer noNested countrystate'}
                                showSearch={true}
                                treeData={props?.stateList?.data ?? []}
                                value={shipmentDetails?.stateName ?? ''}
                                onChange={(e: any) => props?.onShippingInfoChange(e, 'stateName')}
                            />
                            {(shipmentDetails?.error?.stateName) && <Error> {String(t(RESOURCE.MyK_Label_ShoppingCart_State_Req))}</Error>}
                        </div>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-md-6 col-lg-4 col-xl-4 col-6">
                        <div className="mb-1">
                            <label>{t(RESOURCE.MyK_Label_ShoppingCart_Zip)}<span className="mandatory">*</span></label>
                        </div>
                        <div className="col-xl-9 col-lg-9 col-md-12 col-12 pl-0" ref={refs.postalCode}>
                            <input
                                value={shipmentDetails?.postalCode ?? ''}
                                onBlur={(e: any) => props?.onBlurZip(e?.target?.value ?? '')}
                                onChange={(e: any) => props?.onShippingInfoChange(e?.target?.value ?? '', 'postalCode')}
                                type="text" className="textbox" />
                            {(shipmentDetails?.error?.postalCode) && <Error> {String(t(RESOURCE.MyK_Label_ShoppingCart_Zip_Req))}</Error>}
                        </div>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-md-8 col-lg-8 col-xl-7 col-12">
                        <div className="mb-1">
                            <label>{t(RESOURCE.Myk_Label_Phone)}<span className="mandatory">*</span></label>
                        </div>
                        <div className='row'>
                            <div className='col-xl-4 col-lg-3 col-3'  ref={refs.phone}>
                                <TreeviewDropdown
                                    value={shipmentDetails?.phoneCountryCode ?? ''}
                                    onChange={(e: any) => props?.onShippingInfoChange(e ?? '', 'phoneCountryCode')}
                                    treeData={props?.phoneCodeOption}
                                    dropdownClassName={'dropdownListContainer'}
                                    treeNodeFilterProp={"title"}
                                    className={'phone'}
                                    showSearch={true}
                                />
                                {(shipmentDetails?.error?.phoneCountryCode) && <Error> {String(t(RESOURCE.MyK_Label_ShoppingCart_FC_PhoneCode_Req))}</Error>}
                            </div>
                            <div className="col-xl-8 col-lg-9 col-9 pl-0" ref={refs.phoneCountryCode}>
                                {(props?.shipmentDetails?.phoneCountryCode == "+1") ?
                                    <MaskedTextBox
                                        value={shipmentDetails?.phone === '(___) ___-____' ? '' : shipmentDetails?.phone}
                                        onChange={(e: any) => props?.onShippingInfoChange(e.target.value ?? '', 'phone')}
                                        mask="(999) 000-0000"
                                        className='phnumberinput'
                                        ref={phoneInputRef}
                                    /> :
                                    <TextBox
                                        value={shipmentDetails?.phone ?? ''}
                                        onChange={(e: any) => props?.onShippingInfoChange(e.target.value ?? '', 'phone')}
                                        className='phnumberinput'
                                        maxLength={15}
                                        ref={phoneInputRefText}
                                    />
                                }
                                {(shipmentDetails?.error?.phone) && <Error> {String(t(RESOURCE.MyK_Label_ShoppingCart_Phone_Req))}</Error>}
                        </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-12 col-md-12 col-lg-8 col-xl-8" ref={refs.attention}>
                        <div className="mb-1">
                            <label>{t(RESOURCE.MyK_Label_ShoppingCart_FC_Attention)}<span className="mandatory">*</span><span className='ml-2'>({t(RESOURCE.MyK_Label_ShoppingCart_FC_Name)})</span></label>
                        </div>
                        <div>
                            <input
                                type="text" className="textbox"
                                value={shipmentDetails?.attention ?? ''}
                                onChange={(e: any) => props?.onShippingInfoChange(e.target.value ?? '', 'attention')}
                            />
                            {(shipmentDetails?.error?.attention) && <Error> {String(t(RESOURCE.MyK_Label_ShoppingCart_FC_Attention_Req))}</Error>}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ShippingInfo